import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    add (prefix, request) {
      return api.post(`${prefix}/add`, request)
    },

    update (prefix, request) {
      return api.post(`${prefix}/update`, request)
    },

    remove (prefix, request) {
      return api.post(`${prefix}/remove`, request)
    },

    all (prefix) {
      return api.get(`${prefix}/all`)
    },

    zombies (prefix) {
      return api.get(`${prefix}/zombies`)
    },

    cleanse (prefix, request) {
      return api.post(`${prefix}/cleanse`, request)
    },

    info (prefix, request) {
      return api.get(`${prefix}/profile/${request}`)
    }
  }
} else {
  module = {
    _all: [],
    _id: 0,
    _try: 0,

    all () {
      if (this._all.length === 0) {
        for (var i = 0; i !== 100; ++i) {
          this._all.push({
            id: i,
            name: `Test ${i}`,
            firstName: `Jean ${i}`,
            email: [`email@jean${i}.com`, 'email@toto.com'],
            info: [
              {
                'Adresse': `${i} rue des acacias`,
                'Établissement': 'CH Jean Valjean'
              },
              {
                'Adresse': `${i} rue des jonquilles`,
                'Établissement': 'CH Val Jeanval'
              }
            ]
          })
        }
      }
      return delay(1500)({
        data: {
          v: this._all.slice()
        }
      })
    },

    info (prefix, request) {
      const result = this._all.findIndex(e => {
        return e.id === request
      })

      let data = {}
      if (result === -1) {
        data = { err: 'User unknown' }
      } else {
        data = { v: this._all[result] }
      }
      return delay(150)({ data: data })
    },

    add (prefix, request) {
      const id = this._all.length
      let result = {}
      if (this._all.findIndex(e => {
        for (let i in request.em) {
          if (e.email.findIndex(j => {
            return j === request.em[i]
          }) !== -1) {
            return true
          }
        }
        return false
      }) === -1) {
        this._all.push({
          id: id,
          name: request.n,
          firstName: request.f,
          email: request.em
        })
        result = { i: id }
      } else {
        result = { err: 'Email déjà attribué' }
      }

      return delay(150)({ data: result })
    },

    remove (prefix, request) {
      const id = request.i
      const pos = this._all.findIndex(e => {
        return e.id === id
      })

      let result = {}
      if (pos === -1) {
        result.err = 'id not found'
      } else {
        this._all.splice(pos, 1)
      }
      return delay(100)({ data: result })
    },

    login (email, password) {
      this._try++
      const result = (this._try > 1) ? {
        t: 'token',
        n: 'Eiruc',
        f: 'Marie',
        em: 'maire.eiruc@chu-test.fr',
        es: []
      } : { err: 'error' }
      return delay(100)({ data: result })
    }
  }
}

export default module
